import React from 'react'

const IconStartConnector = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_5657_16638)">
        <mask
          id="mask0_5657_16638"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5657_16638)">
          <path
            d="M2.66634 10.334H7.33301V5.66732H2.66634V10.334ZM8.66634 11.6673H1.33301V4.33398H8.66634V7.33398H14.6663V8.66732H8.66634V11.6673Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5657_16638">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconStartConnector
